import MasterItem from "./MasterItem/MasterItem";
import ContentWrapper from "../../UI/ContentWrapper/ContentWrapper";
import DefaultMaster from "./DefaultMaster/DefaultMaster";
import {useParams} from "react-router-dom";
import {EMPLOYER_LIST, GET_MODULES} from "../../apollo/Queries";
import {apolloClientPos, apolloClientPosBranch} from "../../apollo/ApolloClients";
import {useQuery} from "@apollo/client";
import defaultPhoto from './DefaultMaster/defaultMaster.svg';
import {useDispatch, useSelector} from "react-redux";
import {convertDateTimeForRequest} from "../../utils/workingWithDateTime/convertDateTimeForRequest";
import {useEffect, useState} from "react";
import {setDate} from "../../store/dateReducer";
import Spinner from "../../components/Spinner/Spinner";
import {useTranslation} from "react-i18next";
import {setBookingValidate} from "../../store/bookingValidateReducer";
import {NavigationComponent} from "../../components/NavigationComponent/NavigationComponent";
import {POS_URL} from "../../environment";

const MastersList = () => {

    const {t : translate} = useTranslation();
    const {companyId, branchId} = useParams();
    const picketDate = useSelector(state => state.dateReducer.currentDate);
    const dateIsEntered = useSelector(state => state.dateReducer.dateIsEntered);
    const currentService = useSelector(state => state.serviceReducer.serviceId);
    const isBookingValid = useSelector(state => state.bookingValidateReducer.validate);
    const dispatch = useDispatch();
    const [isReviewsActive, setIsReviewsActive] = useState(false);
    const [isAnyAllowDefault, setIsAnyAllowDefault] = useState(false);

    const {data: employerList, loading: loadingEmployee} = useQuery(EMPLOYER_LIST,
        {
            client: apolloClientPosBranch,
            variables: {
                branchId: branchId,
                picketDate: dateIsEntered ? convertDateTimeForRequest(picketDate) : null,
                serviceId: currentService,
                online : true
            },
            onCompleted: (data) => {
                const isAnyAllowDefault = data.employees.some(employee => employee?.allowDefault);
                setIsAnyAllowDefault(isAnyAllowDefault);
            }
        });

    const {loading : loadingModules} = useQuery(GET_MODULES, {
        client: apolloClientPos,
        variables: {
            companyId: Number(companyId),
        },
        onCompleted: (data) => {
            const REVIEWS = data?.relations?.modules?.find((module) => {
                return module.name === "Reviews";
            });
            if (REVIEWS) {
                setIsReviewsActive(REVIEWS.active);
            }
        }
    })

    useEffect(() => {
        if (!dateIsEntered) {
            dispatch(setDate({currentDate: null, dateIsEntered: false}))
        }
        if (!isBookingValid) {
            dispatch(setBookingValidate({validate : true}))
        }
    }, [dateIsEntered, dispatch, isBookingValid]);
    return (
        <>
            <div className={"bg-white"}>
                <NavigationComponent
                    navLink={`/company/${companyId}/branch-menu-list/${branchId}`}
                    linkText={translate('backToMenu')}
                />
            </div>
            <div className="masters">
                <div className="master-items-list">
                    {(employerList && employerList.employees && employerList.employees.length !== 0) ?
                        <>
                            {(employerList.employees.length > 1 && isAnyAllowDefault) && (<DefaultMaster companyId={companyId} branchId={branchId}/>)}
                            {
                                employerList.employees.map((employeeItem) => (
                                    <ContentWrapper key={employeeItem.id}>
                                        <MasterItem
                                            masterName={employeeItem.name}
                                            masterPosition={employeeItem.position.name}
                                            masterDesc={employeeItem.specialization}
                                            aboutMaster={employeeItem.aboutMe}
                                            masterNearestEntry={picketDate ? picketDate : employeeItem.closestBookingDate}
                                            masterPhoto={employeeItem.image ? `${POS_URL}/${employeeItem.image}` : defaultPhoto}
                                            closestBookingDateTimes={employeeItem.closestBookingDateTimes}
                                            employeeId={employeeItem.id}
                                            avgRating={employeeItem.avgRating}
                                            reviewCount={employeeItem.reviewCount}
                                            employeeServiceRelation={employeeItem.employeeServiceRelation}
                                            masterSurname={employeeItem.surname}
                                            isReviewsActive={isReviewsActive}
                                        />
                                    </ContentWrapper>
                                ))
                            }
                        </>
                        : <p className={"mb-0 text-secondary text-center"}>{translate('masterListPage.employeeNotFound')}.</p>
                    }
                    {(loadingEmployee || loadingModules)? <Spinner/> : null}
                </div>
            </div>
        </>
    )
}

export default MastersList